import { z } from 'zod';
import { selfServiceAllowedCountryCodeValues } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';

import { ProjectNeedsSchema } from './project-needs';

export const ProjectNeedsWithLegalSkillsSchema = ProjectNeedsSchema.extend({
  addressCountryCode: z
    .enum(ZodArrayToEnum(selfServiceAllowedCountryCodeValues))
    .nullable(),
  legalSkillsAnswers: z.array(z.array(z.string()).nullish()).nullish(),
});

export type ProjectNeedsWithLegalSkills = z.infer<
  typeof ProjectNeedsWithLegalSkillsSchema
>;
